import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-delete-product.hbs';

    var DeleteProductDialog = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        initialize: function(options) {
            this.destroyOnClose();
            this.focusFirstInput();
        },
        ui: {
            alert: '.modal-alert-container > .alert',
            alert_container: '.modal-alert-container',
            product_name_confirm: '#delete-product-confirm-name',
            submit_btn: 'button[type="submit"]'
        },
        events: {
            'keyup @ui.product_name_confirm': 'check_validation',
            'change @ui.product_name_confirm': 'check_validation',
            'submit form': 'on_submit',
        },
        check_validation: function() {
            var product_name = this.model.get('name').trim().toLowerCase();
            var product_name_confirm = this.ui.product_name_confirm.val().trim().toLowerCase();

            if (product_name === product_name_confirm) {
                this.ui.submit_btn.prop('disabled', false);
            } else {
                this.ui.submit_btn.prop('disabled', true);
            }
        },
        on_submit: function(e) {
            e.preventDefault();
            this.hideAlert();

            this.model.destroy({
                wait: true,
                success: _.bind(this.on_success, this),
                error: _.bind(this.on_error, this),
            });
        },
        on_success: function() {
            this.closeDialog();
            if (this.options.success) this.options.success(this.model);
        },
        on_error: function(product, resp) {
            var errors = ['An error occurred while attempting to delete this product.'];
            if (resp 
             && resp.responseJSON 
             && resp.responseJSON.errors
             && resp.responseJSON.errors.length
            ) {
                errors = _.map(resp.responseJSON.errors, function(err) {
                    return err.detail;
                });
            }

            this.showAlert('error', errors.join(' '));
        }
    });
    export default DeleteProductDialog;

